<template>
	<div class='knd-article-slide knd-article-slide-conclusie'>
		<div class="knd-article-slide-conclusie-title">Conclusie</div>
		<div class="circle">
			<div class="circle__inner">
				<div class="circle__wrapper">
					<div class="circle__content">
					<div class="circle__content-img-container">
						<img class="circle__content-img" :src="getAsset('images/conclusie-'+ conclusie.id +'.png')" />
						</div>
					Deze uitspraak is <span>{{conclusie.label}}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
<!-- 
		<div class="conclusie-slide">
			<div class='text'>
				<p>Deze uitspraak is {{conclusie.label}}</p>
			</div>
		</div>
	</div>	 -->		
</template>

<script>
	const vueObject = {
		props: ['conclusie'],
		components: {
		},
		mounted: function() {},
		methods: {
			
		}
	}

	export default vueObject;
</script>